// 페어 모델 헬퍼 — 다중 레그(바스켓) 지원 + 구모델({longTicker,shortTicker}) 호환.
// 신모델: { longs: [{ticker,name,market}], shorts: [{ticker,name,market}] }

export function pairLegs(p) {
  if (!p) return { longs: [], shorts: [] };
  if (Array.isArray(p.longs) || Array.isArray(p.shorts)) {
    return { longs: p.longs || [], shorts: p.shorts || [] };
  }
  // 구모델 → 신모델
  return {
    longs: p.longTicker ? [{ ticker: String(p.longTicker), name: p.longName || String(p.longTicker), market: p.longMarket || "KR" }] : [],
    shorts: p.shortTicker ? [{ ticker: String(p.shortTicker), name: p.shortName || String(p.shortTicker), market: p.shortMarket || "KR" }] : [],
  };
}

// 저장용으로 항상 신모델로 정규화
export function normalizePair(p) {
  const { longs, shorts } = pairLegs(p);
  return { longs, shorts };
}

export function pairId(p) {
  const { longs, shorts } = pairLegs(p);
  return "L" + longs.map((l) => l.ticker).join("+") + "_S" + shorts.map((l) => l.ticker).join("+");
}

export function samePair(a, b) {
  return pairId(a) === pairId(b);
}

// 표시용 라벨 (이름 나열)
export function legLabel(legs) {
  return (legs || []).map((l) => l.name || l.ticker).join(" + ");
}
